import { Component, Injector, NgModule, OnInit, inject, viewChild } from '@angular/core';
import { idNameItem, jkAlert, JkBaseOption, jkLib, jkRestReturn, } from 'jk-service';
import { MaterialModule, } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, jkQueryComponent } from 'jk-advcom';
import { stklg002List } from '../_service_stk';
import { JkrangeComponent } from 'jk-advcom';
import { stockConvert, StockQuote } from '../services/stockBase';
import { capitalQuoteOption, SKSTOCKLONG } from '../capitalClass';


export class FilterOption extends JkBaseOption {
  stktmHaveSet: boolean = false; // ###
  stockHost: string = 'http://localhost:9086'; // ###
  kind: string = '日線'; // ###
  stockNo: string = '0050';
  stklg002: string = '日線';
  order: string = '';
  kindList = stklg002List; // idNameItem[] = [{ id: '1', name: '日線' }, { id: '2', name: '指數' }, { id: '3', name: '期貨' }, { id: '4', name: '選擇權' }];
  get stklg002List() {
    return stklg002List;
  }

}

class PageOption extends JkBaseOption { // ###
  rgDateValueA: string = '';
  rgDateValueB: string = '';
}

//let pq09Parent: Stkpq09Page; // ###



@Component({
  selector: 'app-stkpq09',
  templateUrl: './stkpq09.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule,
  ],
})
export class Stkpq09Page extends jkQueryComponent implements OnInit {
  override _programId = 'stkpq09'; //###
  readonly rgDate = viewChild.required<JkrangeComponent>('rgDate');
  pageOpt: PageOption = new PageOption(this.programId + '_page'); //###
  filterOpt: FilterOption = new FilterOption(this.programId); //###
  stkma001List: idNameItem[] = [];
  hostList: idNameItem[] = [{ id: 'http://localhost:9086', name: '本機9086' }, { id: 'http://jk-ubun:9086', name: '虛擬機jk-ubun:9086' }];
  orderList: idNameItem[] = [{ 'id': 'ORDER BY TM002', 'name': '商品代號' }];// [{'id':'ORDER BY LG001,LG002,LG003,LG004','name':'日期順序'},{'id':'ORDER BY LG001 DESC,LG002 DESC,LG003 DESC,LG004 DESC','name':'日期倒序'}];

  stkConv: stockConvert;
  constructor() {
    super();
    this.setFormOpt2();//###
    /*this.filterOpt = new FilterOption(this.programId);//###
    this.pageOpt = new PageOption(this.programId + '_page');//###*/
    //pq09Parent = this;//###
    this.logMessage = '無錯誤訊息';
    this.stkConv = new stockConvert();
    //this.stkma001List = await jkOpenWin.doOpenWin<idNameItem[]>('S','#STKMA001','V01',[]);
    this.addOpenwinLoadOption('#STKMA001', 'V01', 'S', [], this.stkma001List);
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    //this.masterGridSet.init(this.masterGrid, this.qryMaster);
    //this.detailGridSet.init(this.detailGrid, this.qryDetail as JkEntity);
    setTimeout(() => {
      this.titlebarCom.onUser1Click = this.doRefresh.bind(this);
      this.titlebarCom.user1Text = '重新顯示';
      this.titlebarCom.user1Visible = true;
      this.titlebarCom.onUser2Click = this.doCapitalQuote.bind(this);
      this.titlebarCom.user2Text = '更新群益發佈';
      this.titlebarCom.user2Visible = true;
      this.titlebarCom.onUser3Click = this.doTest.bind(this);
      this.titlebarCom.user3Text = '測試';
      this.titlebarCom.user3Visible = true;
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式

    }, 1000);


    this.checkAllInit(this);// 這行要放在 ngAfterViewInit 最後  ###
    //await this.doQuery();
  }
  ngOnExit() {
  }
  override onWindowResize() { // ###
    super.onWindowResize();
    //this.pageOpt.setColCount(window.innerWidth);
  }

  onFocusedRowChanged(e: any) {
    //this.itemForm.get('TM110')?.setValue(e.row.data.TM110);
    /*
    Object.keys(pq09Parent.itemForm.controls).forEach((element) => {
      let data = e.row.data[element];
      if(data){
        pq09Parent.itemForm.controls[element].setValue(data);
        //pq09Parent.itemForm.value[elelent] = e.row.data.TM110;
      }
    });
    */
  }
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    this.where = '';
    if (this.filterOpt.kind === '日線') {

      //await this.gridMain.init('STKPQ09','S01','S',['TM001'],[]);
      this.type = 'S';
      this.winItem = 'S01';
      this.mainTable = this.programId;
      this.where = this.where + ` AND (TM110 <> 0 OR TM111 <> 0 OR TM112 <> 0 OR TM113 <> 0
        OR TM114 <> 0 OR TM115 <> 0 OR TM116 <> 0 OR TM117 <> 0)
        `;


    }
    //this.where = jkLib.text2Where(this.pageOpt.stklg002, this.where, "LG002", '=');
    //this.where = this.rgDate.addWhere(this.where,"LG004");


    // this.gridMain.sqlWhere = '';
    return true;
  }

  // ### [以上是必要的]================================
  async doCapitalQuote() {
    //let stockNo = '';
    let quoteOpt = new capitalQuoteOption();
    quoteOpt.message = '#capital#quote#client:' + this.orm.ip();
    quoteOpt.stockNo = '2330';
    quoteOpt.action = 'query_stock';
    const urlParam = '';
    let sh = this.filterOpt.stockHost;
    if (sh == '') {
      sh = 'http://jk2022:9086';
    }
    const mReturn = await jkLib.doFetch(sh, '/capital/quote_websocket', urlParam, this.login.token, 'post', quoteOpt);

  }
  async doTest() {

  }
  onGetMessage(parent: any, ret: jkRestReturn) {
    console.log('onGetMessage:' + ret.message);
    if (ret.message.startsWith('stock,quote,')) {
      let obj = JSON.parse(ret.data);
      parent.parseQuoteMessage(obj);
    };
  }
  override async doRefresh(): Promise<void> {
    super.doRefresh();
    return;
  }
  async parseQuoteMessage(obj: any) {
    /*  stock||quote||{"nStockIdx":0,"sDecimal":2,"sTypeNo":201,"bstrMarketNo":"2","bstrStockNo":"TX00","bstrStockName":"台指近","nOpen":0,"nHigh":0,"nLow":0,"nClose":0,"nTickQty":0,"nRef":1492500,"nBid":0,"nBc":0,"nAsk":0,"nAc":0,"nTBc":0,"nTAc":0,"nFutureOI":0,"nTQty":0,"nYQty":0,"nUp":1641700,"nDown":1343300,"nSimulate":0,"nDayTrade":0,"nTradingDay":20230118,"nTradingLotFlag":-1}
     */
    //let msg = ret.data;
    //let ary = msg.split('||');
    //if (ary.length !== 3) return;
    //if(ary[0] !== 'stock') return;
    //if(ary[1] !== 'quote') return;
    return; // TODO: 這個功能先不用
    try {
      //let itemList = this.gridMain.itemList;
      let quote: SKSTOCKLONG = obj;
      //stockPrice.nStockIdx = quote.nStockIdx;
      let stockno = quote.bstrStockNo;
      let ndx = this.itemList.findIndex((item) => {
        return item.TM002 === stockno;

      });
      if (ndx < 0) return;
      let item: StockQuote = this.itemList[ndx];

      //this.stkConv.CapitalSKSTOCKLONG2StockQuote(quote, item);
      //await this.checkWarning(item);
    } catch (error: any) {
      jkAlert('parseQuoteMessage error:' + error.message);
    }
  }



}


